import React, {useContext} from "react";
import {withAuth} from "../../hoc/Auth";
import {Column, Container, Wrapper} from "../../hoc/Layout";
import {FormattedMessage} from "react-intl";

import TabBarItem from "../../Components/Utils/HTabBar/TabBarItem";
import HTabBar from "../../Components/Utils/HTabBar";

import General from "./General"
import Security from "./Security";

import classes from "./styles.module.css";

import MessageContext from "../../MessageContext";
import Logo from "../../Components/Logo";

const Profile = withAuth(({token, logout, forcedPasswordChange, requires2FASetup, clear2FASetupFlag, authorize, isRemember}) => {

    const {onMessage} = useContext(MessageContext);

    // Определяем режим ограниченного доступа (смена пароля или настройка 2FA)
    const isRestrictedMode = forcedPasswordChange || requires2FASetup;
    // Определяем нужно ли показывать только Security вкладку (только 2FA без смены пароля)
    const showOnlySecurity = requires2FASetup && !forcedPasswordChange;

    const content = (
        <React.Fragment>
            {requires2FASetup && !forcedPasswordChange && (
                <div className={classes.WarningBanner}>
                    <FormattedMessage
                        id={'Profile.warning.requires2FASetup'}
                        defaultMessage={'Для продолжения работы необходимо настроить двухфакторную аутентификацию'}
                    />
                </div>
            )}

            <div className={classes.Card}>
                <div className={classes.CardHeader}>
                    <h5><FormattedMessage id={'Profile.title.myProfile'} defaultMessage={'no translate'}/></h5>
                </div>

                <HTabBar defaultActiveTab={showOnlySecurity ? 1 : 0}>
                    <TabBarItem label='Общие настройки' isVisible={!showOnlySecurity}>
                        <div className={classes.Content}>
                            <General token={token} logout={logout}
                                     forcedPasswordChange={forcedPasswordChange}
                                     onMessage={(val) => onMessage(val)}/>
                        </div>
                    </TabBarItem>

                    <TabBarItem label='Безопасность'
                                isVisible={!forcedPasswordChange || showOnlySecurity}>
                        <div className={classes.Content}>
                            <Security
                                token={token}
                                logout={logout}
                                forcedPasswordChange={forcedPasswordChange}
                                requires2FASetup={requires2FASetup}
                                clear2FASetupFlag={clear2FASetupFlag}
                                authorize={authorize}
                                isRemember={isRemember}
                                onMessage={(val) => onMessage(val)}
                            />
                        </div>
                    </TabBarItem>
                </HTabBar>
            </div>
        </React.Fragment>
    );

    if (isRestrictedMode) {
        return (
            <React.Fragment>
                <div className="d-flex justify-content-between align-items-center px-4 py-3"
                     style={{background: 'rgb(21, 42, 68)'}}>
                    <Logo/>
                    <button onClick={logout} className="btn btn-outline-light btn-sm">Выйти</button>
                </div>

                <div className="mx-auto" style={{maxWidth: '800px', padding: '0 15px'}}>
                    <Container style={{paddingTop: "1.25rem"}}>
                        <Column width={780}>{content}</Column>
                    </Container>
                </div>
            </React.Fragment>
        );
    }

    return (
        <Wrapper>
            <Container style={{justifyContent: "center"}}>
                <Column width={'100%'}>{content}</Column>
            </Container>
        </Wrapper>
    );
});

export default Profile;



// WEBPACK FOOTER //
// ./src/PagesOfUser/Profile/index.js